const KNOWN_KINDS = new Set(['raw', 'text', 'date', 'number']);
const NUMBER_DATATYPES = new Set(['number', 'decimal', 'currency']);
const TEXT_DATATYPES = new Set(['text', 'string']);
/**
 * Canonicalizes a (possibly legacy) column-like object into a ColumnFormatSpec.
 * This is the single read-time-tolerance + legacy-fold helper: it is reused by
 * the runtime resolver, the preview renderer, and the backfill script so they
 * cannot diverge. Unknown / absent shapes degrade to { kind: 'raw' } — never throws.
 */
export function normalizeColumnFormat(col, opts) {
    const explicit = col.format;
    if (explicit && KNOWN_KINDS.has(explicit.kind)) {
        return explicit;
    }
    const dt = col.dataType;
    if (dt === 'date') {
        return { kind: 'date', token: col.dateFormat ?? opts?.dateFallback ?? 'YYYY-MM-DD' };
    }
    if (dt && NUMBER_DATATYPES.has(dt)) {
        return { kind: 'number', ...(col.numberFormat ?? {}) };
    }
    if (dt && TEXT_DATATYPES.has(dt)) {
        return { kind: 'text' };
    }
    return { kind: 'raw' };
}
/**
 * Resolves a per-form mapping's override spec, or undefined when the mapping
 * inherits the column contract. Folds legacy flat dateFormat/numberFormat.
 */
export function normalizeMappingOverride(mapping) {
    if (mapping.formatOverride && KNOWN_KINDS.has(mapping.formatOverride.kind)) {
        return mapping.formatOverride;
    }
    if (mapping.dateFormat) {
        return { kind: 'date', token: mapping.dateFormat };
    }
    if (mapping.numberFormat) {
        return { kind: 'number', ...mapping.numberFormat };
    }
    return undefined;
}
//# sourceMappingURL=column-format-spec.js.map